import React from 'react';
import StartupCashManagement from './components/startup-cash-management';

function App() {
  return (
    <div className="App">
      <StartupCashManagement />
    </div>
  );
}

export default App;
